import Http from '../utils/http'

export const getAllPaged = (page = 1, extraParams = {}) => Http.get('/incoming', { params: { page, ...extraParams } })

export const uploadFile = (payload) => Http.post('/incoming/upload-file', payload)

export const importFile = (payload) => Http.post('/incoming/import', payload)

export const refuse = (id) => Http.put(`/incoming/${id}/refuse`)

export const accept = (id) => Http.put(`/incoming/${id}/accept`)

export const update = (id, payload) => Http.put(`/incoming/${id}`, payload)

export const refuseAll = (payload) => Http.put(`/incoming/refuse`, payload)

export const acceptAll = (payload) => Http.put(`/incoming/accept`, payload)



// WEBPACK FOOTER //
// ./src/services/incoming.js